import { Colors, MagicBox } from "@brg/ui"
import styled, { css } from "styled-components"
import Close from "../../../assets/Close.svg"
import Chevron from "../../../assets/Chevron.svg"
import { LayoutConst } from "core"
import { QueuePoint } from "../QueueLineNew/QueueLineNew"

export const QueueCircleWrapper = styled.div<{
    size: number
    isCurrent?: boolean
    isStatic?: boolean
    isLastPoint?: boolean
    zIndex?: number
    bottomText?: string
    border?: string
    col: {
        text: string
        bg: string
    };
    pos: string
    point: QueuePoint
}>`
    user-select: none;
    height: ${p => p.size ? `${p.size}px` : "41px"};
    width: ${p => p.size ? `${p.size}px` : "41px"};
    min-width: ${p => p.size ? `${p.size}px` : "41px"};
    // padding: ${p => `0 ${16-(40-p.size)/2}px`};
    background-color: ${p => p.col?.bg};
    color: ${p => p.col?.text};

    position: ${p => p.isStatic ? 'static' : 'absolute'};
    top: ${p => p.size ? `${-p.size/2}px` : "-21px"};
    transition: 0.2s;

    left: ${p => p.pos};
    border: ${p => p.border || 'none'};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${p => p.zIndex ?? "auto"};

    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: ${p => p.isLastPoint ? 'end': 'center'};

    &:hover {
        z-index: 10000;
    }

    // &::after {
    //     content: "${p => p.bottomText ?? ""}";
    //     color: ${p => p.col?.text};
    //     position: absolute;
    //     top: ${p => p.size+4}px;

    //     font-family: Inter;
    //     font-size: 13px;
    //     font-weight: 400;
    //     line-height: 16px;
    //     text-align: center;
    // }

/*    @media screen and (max-width: ${LayoutConst.screen.m}px) {
        top: ${p => p.pos};
        left: auto;
        position: relative;

        &::after {
            left: calc(100% + 4px);
            top: auto;
        }
    }*/
`

export const CircleHoverHint = styled.div`
    text-align: center;
    font-family: Inter;

    font-size: 13px;
    font-weight: 400;
    line-height: 16px;

    & span {
        font-size: 10px;
        font-weight: 500;
        line-height: 13px;
        letter-spacing: 0.06em;
        color: ${Colors.galBlack21};
    }
` 

export const CircleMore = styled.div`
    margin: 4px 10px 12px;
`

export const CircleClose = styled.div`
    background: url(${Close});
    height: 16px;
    width: 16px;
    background-repeat: no-repeat;
    background-position: center;
`

export const CircleChevron = styled.div<{
    direction: "left" | "right"
}>`
    background: url(${Chevron});
    height: 16px;
    width: 16px;
    background-repeat: no-repeat;
    background-position: center;
    transform: rotateZ(${p => p.direction === "left" ? "90deg" : "-90deg"});
`

export const TopCircleText = styled.div<{
    color?: string
    size?: number
    isStartPoint?: boolean
}>`
    position: absolute;
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    color: ${p => p.color ?? Colors.galBlack47};

    white-space: nowrap;
    // top: ${p => p?.size !== undefined ?  -(p?.size / 2 + 1) : -25}px;
    top: -27px;
    ${({ isStartPoint }) => isStartPoint && css`
        left: 0;
    `};

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        top: 25px;
        white-space: pre-wrap;
        font-size: 10px;
        line-height: 13px;
        height: 26px;
        text-align: left;

    ${({ isStartPoint }) => !isStartPoint && css`
        width: 96px;
        text-align: center;
    `};
    }
`

export const BottomCircleText = styled(MagicBox)<{
    color?: string
    isLast: boolean
    size: number
}>`
    position: absolute;
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    text-align: ${p => p.isLast ? 'end' : 'center'};
    top: ${p => p.size + 4}px;
    color: ${p => p.color ?? Colors.galBlack47};
`

export const QueueUserCircle = styled.div<{
    pos: string
    bottomText?: string
}>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: -20px;
    left: ${p => p.pos};
    background-color: #F2BDE0;
    color: ${Colors.galBlack100};

    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;

    &::after {
        content: "${p => p.bottomText ?? ""}";
        color: ${Colors.galBlack100};
        position: absolute;
        bottom: 44px;

        font-family: Inter;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        text-align: center;
    }

    @media screen and (max-width: ${LayoutConst.screen.m_1024}px) {
        top: ${p => p.pos};
        left: auto;

        &::after {
            top: auto;
            right: calc(100% + 4px);
        }
    }
`
import { Colors, MagicBox } from "@brg/ui"
import styled, { css } from "styled-components"
import Close from "../../../assets/Close.svg"
import Chevron from "../../../assets/Chevron.svg"
import { LayoutConst } from "core"
import { QueuePoint } from "../QueueLineNew/QueueLineNew"

export const QueueCircleWrapper = styled.div<{
    size: number
    isCurrent?: boolean
    isStatic?: boolean
    isLastPoint?: boolean
    zIndex?: number
    bottomText?: string
    border?: string
    col: {
        text: string
        bg: string
    };
    pos: string
    point: QueuePoint
}>`
    user-select: none;
    height: ${p => p.size ? `${p.size}px` : "41px"};
    width: ${p => p.size ? `${p.size}px` : "41px"};
    min-width: ${p => p.size ? `${p.size}px` : "41px"};
    // padding: ${p => `0 ${16-(40-p.size)/2}px`};
    background-color: ${p => p.col?.bg};
    color: ${p => p.col?.text};

    position: ${p => p.isStatic ? 'static' : 'absolute'};
    top: ${p => p.size ? `${-p.size/2}px` : "-21px"};
    transition: 0.2s;

    left: ${p => p.pos};
    border: ${p => p.border || 'none'};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: ${p => p.zIndex ?? "auto"};

    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: ${p => p.isLastPoint ? 'end': 'center'};

    &:hover {
        z-index: 10000;
    }

    // &::after {
    //     content: "${p => p.bottomText ?? ""}";
    //     color: ${p => p.col?.text};
    //     position: absolute;
    //     top: ${p => p.size+4}px;

    //     font-family: Inter;
    //     font-size: 13px;
    //     font-weight: 400;
    //     line-height: 16px;
    //     text-align: center;
    // }

/*    @media screen and (max-width: ${LayoutConst.screen.m}px) {
        top: ${p => p.pos};
        left: auto;
        position: relative;

        &::after {
            left: calc(100% + 4px);
            top: auto;
        }
    }*/
`

export const CircleHoverHint = styled.div`
    text-align: center;
    font-family: Inter;

    font-size: 13px;
    font-weight: 400;
    line-height: 16px;

    & span {
        font-size: 10px;
        font-weight: 500;
        line-height: 13px;
        letter-spacing: 0.06em;
        color: ${Colors.galBlack21};
    }
` 

export const CircleMore = styled.div`
    margin: 4px 10px 12px;
`

export const CircleClose = styled.div`
    background: url(${Close});
    height: 16px;
    width: 16px;
    background-repeat: no-repeat;
    background-position: center;
`

export const CircleChevron = styled.div<{
    direction: "left" | "right"
}>`
    background: url(${Chevron});
    height: 16px;
    width: 16px;
    background-repeat: no-repeat;
    background-position: center;
    transform: rotateZ(${p => p.direction === "left" ? "90deg" : "-90deg"});
`

export const TopCircleText = styled.div<{
    color?: string
    size?: number
    isStartPoint?: boolean
}>`
    position: absolute;
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    text-align: center;
    color: ${p => p.color ?? Colors.galBlack47};

    white-space: nowrap;
    // top: ${p => p?.size !== undefined ?  -(p?.size / 2 + 1) : -25}px;
    top: -27px;
    ${({ isStartPoint }) => isStartPoint && css`
        left: 0;
    `};

    @media screen and (max-width: ${LayoutConst.screen.s-1}px) {
        top: 25px;
        white-space: pre-wrap;
        font-size: 10px;
        line-height: 13px;
        height: 26px;
        text-align: left;

    ${({ isStartPoint }) => !isStartPoint && css`
        width: 96px;
        text-align: center;
    `};
    }
`

export const BottomCircleText = styled(MagicBox)<{
    color?: string
    isLast: boolean
    size: number
}>`
    position: absolute;
    font-family: Inter;
    font-size: 13px;
    font-weight: 400;
    line-height: 16px;
    text-align: ${p => p.isLast ? 'end' : 'center'};
    top: ${p => p.size + 4}px;
    color: ${p => p.color ?? Colors.galBlack47};
`

export const QueueUserCircle = styled.div<{
    pos: string
    bottomText?: string
}>`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: -20px;
    left: ${p => p.pos};
    background-color: #F2BDE0;
    color: ${Colors.galBlack100};

    font-family: Inter;
    font-size: 17px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: -0.02em;
    text-align: center;

    &::after {
        content: "${p => p.bottomText ?? ""}";
        color: ${Colors.galBlack100};
        position: absolute;
        bottom: 44px;

        font-family: Inter;
        font-size: 13px;
        font-weight: 400;
        line-height: 16px;
        text-align: center;
    }

    @media screen and (max-width: ${LayoutConst.screen.m_1024}px) {
        top: ${p => p.pos};
        left: auto;

        &::after {
            top: auto;
            right: calc(100% + 4px);
        }
    }
`
